import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-header-icon-switcher';

@customElement(CName)
export class UIHeaderIconSwitcher extends LitElement {
  render() {
    return html`<ui-sprite-svg .iconID=${'header-icon-switcher'}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIHeaderIconSwitcher;
  }
}
